import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const EmailField = () => {
  return (
    <FormField label="Email Address" htmlFor="email">
      <FormikInput id="email" name="email" />
    </FormField>
  );
};

export default EmailField;
